<template>
    <div>
      <div class="pretty plain smooth toggle heart" v-if="item && item.BookGroupID">
          <input type="checkbox" v-model="item.IsSubscribe" :id="item.BookID || item.BookGroupID" @click="addOrRemoveSubscribe(item,$event)">
          <label><i class="fa fa-heart-o"></i></label>
          <label><i class="fa fa-heart info"></i></label>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'

export default {
  name: 'Subscribe',
  props: ["book"],
  data () {
    return {
      item: this.book
    }
  },
  methods: {
    ...user
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>


// WEBPACK FOOTER //
// src/Subscribe.vue